<template>
  <div class="content-box over">
    <div class="de-title">


      <div class="taps">
        <div style="height: 6px;"></div>
        <div class="dis taps-li">
          <div class="taps-lia" :class="['cupo',tapIndex==index?'all-active-aa':'']" v-for="(item,index) in [{
    name: '求购中心',
    val: 0

  }, {
    name: '供应中心',
    val: 1
  }]" :key="index" @click="fenlei(index)">



            <img :src="'/static/imgs/tap' +  (item.val + 1 )+ (tapIndex == index ? '' :  (item.val + 1 )) + '.png'"
              fit="cover" style="margin-bottom: -3px; width:20px ;height: 20px;" />


            {{item.name}}
          </div>
        </div>

      </div>



      <div class="bom">
        <div class="pad-s over">
          <p class="fl m-lei">商品分类：</p>
          <div class="fl over">
            <p :class="['fl li-cz cupo',czIndex == index ? 'all-active' : '']" v-for="(item,index) in varBox"
              @click="varClick(item,index)" :key="index">{{item.itemValue}}</p>

          </div>
        </div>
      </div>
    </div>


    <div class="qg-box" v-if="!tapIndex" v-loading="qgLoading"
      :style="qgBox.length?'':'background: #fff;padding:21px 0;'">
      <div v-if="!qgShow" class="qg-min dis" style="flex-wrap: wrap;">

        <router-link class="qg-box-list" v-for="(item,index) in qgBox" :key="index" @click.native="seekClick(item)"
          :to="'/demand/seekarticle/id/'+item.id +  '/member/' + item.creatorId + '/company/' + item.companyId"
          style="display: block;">


          <div class="qg-box-pad ">
            <div class="over" style="padding: 8px 0;">
              <el-image :src="item.userHeadUrl ? $imgUrl + item.userHeadUrl  : '/static/imgs/dimg.png'" fit="cover"
                class="fl qgtt" />

              <div class="fl qgttt">{{item.companyName}}</div>
            </div>
          </div>

          <div style="background: #fff;border-radius:  0 0 12px 12px;">

            <div style="padding: 0 12px;">

              <div class="jxsa over">
                <el-image :src="'/static/imgs/'+ datms.qgTag.find((items) => items.val == item.tagId).img" fit="cover"
                  v-if="item.tagId" class="biaoqian fl" style="margin-right: 12px;margin-top: 5px;" />
                <p class="clamp1 clamp1222 fl">{{item.title}}</p>
              </div>

              <div class="mkl16 over">

                <p class="fl w192 clamp1" style="width: 190px;">
                  求购分类：{{varBox.find((items) => items.itemCode == item.categoryId).itemValue}}</p>
                <p class="fl w192 clamp1">采购数量：{{item.quantity || '不限'}}<span class="col"
                    v-if="item.quantity && item.unitName && item.quantity!='不限'">{{' ' + item.unitName}}</span></p>
                <p class="fl  clamp1" style="width: 120px;">收货地：{{item.addressDisplay || '不限'}}</p>

              </div>

              <div class="mkl16 over">

                <p class="fl w192 clamp1" style="width: 190px;">
                  联系电话：{{item.telePhone.replace(/(\d{3})\d{4}(\d{4})/, '$1 **** $2')}} </p>
                <p class="fl w192 clamp1">发布时间：{{item.createDate.split(" ")[0]}}</p>
                <p class="fl  clamp1" style="width: 120px;">配送方式：{{item.shippingMethod?'物流配送':'自提'}}</p>

              </div>

              <div class="mkl16 over">

                <p class="fl w192 clamp1">是否含税：{{item.taxRateType?'含税':'不含税'}}</p>


              </div>

              <div style="height: 1px;
background: #D9D9D9;"></div>



              <div class="dis">
                <p class="liulan">浏览量：<span class="kan">{{item.browseQuantity}}</span></p>
                <p class="lvbtn">查看详情</p>
              </div>

            </div>

          </div>


          <el-image src="/static/imgs/ycj.png" fit="cover" class="ycjico" style="right: 12px;top: 2px;"
            v-if="item.status == 2" />

        </router-link>
      </div>
      <div v-else class="dis kkin">
        <el-image src="/static/imgs/emp.png" class="sty200" fit="cover" />
        <span class="bq">抱歉，没有找到相关求购</span>
      </div>
    </div>

    <div class="gy-box" v-if="tapIndex" v-loading="gyLoading">
      <div class="gy-pad">
        <div class="data-list over" v-if="!gyShow">

          <router-link v-for="(item,index) in gyBox" :key="index"
            :to="'/demand/supplyarticle/id/'+item.id +  '/member/' + item.creatorId + '/company/' + item.companyId"
            style="display: block;" :class="['hot-list-gy fl', (index+1)%5 === 0 ?'mr-num-0':'mr-num']">
            <div class="img-box-gy cupo" @mouseover="blackShow(index,item)" @mouseleave="dataLeav">

              <el-image
                :src="$imgUrl + (item.supplyAdvPictures[0].pictureUrl.includes('.mp4') ? item.supplyAdvPictures[1].pictureUrl : item.supplyAdvPictures[0].pictureUrl)"
                fit="cover" class="wh100" style="border-radius: 12px;" />
              <div class="list-black" v-if="item.black">
                <div class="qrbox">
                  <canvas id="QRCode_header"></canvas>
                </div>
                <span class="saoma">扫码查看详情</span>
              </div>
            </div>
            <div class="box-pading">
              <div class="jx dis">
                <el-image :src="'/static/imgs/'+ datms.gyTag.find((items) => items.val == item.tagId).img" fit="cover"
                  class="taisty" v-if="item.tagId" />
                <p class="list-tit clamp1" style="width: 140px;">{{item.description}}</p>
              </div>
              <p class="dis" style="justify-content: flex-start;">
                <el-image :src="item.userHeadUrl ? $imgUrl + item.userHeadUrl  : '/static/imgs/dimg.png'" fit="cover"
                  class="toutou" />
                <span class="my">{{item.creatorName}}</span>
              </p>
              <div class="dis klo">
                <p class="clamp1">
                  <i class="el-icon-location-outline" style="font-size: 14px;"></i> {{item.shipProvinceName}}
                  {{item.shipCityName}}
                </p>
                <p class="rq clamp1" style="color:#848691 ;width: 70px;">{{item.createDate.split(' ')[0]}}</p>
              </div>
              <p style="margin-top: 6px;  color: #f22424;">
                <span style="font-weight: bold;font-size: 12px;" v-if="item.specPrice != -1 ">￥</span> <span
                  class="red-wight-2">{{item.specPrice == -1 ?'电议':item.specPrice}}</span><span style="font-size: 12px;"
                  v-if="item.specPrice != -1 ">/{{item.unitName}}</span>
              </p>
            </div>
          </router-link>
        </div>

        <div v-else class="dis" style="width: 388px;margin: 0 auto;">
          <el-image src="/static/imgs/emp.png" fit="cover" style="width: 200px;height: 200px;" />

          <span class="bq">抱歉，没有找到相关供应</span>
        </div>

      </div>
    </div>

    <div style="float: right;margin: 10px 0;">
      <pagesK :tootle="total" :pageSize="tapIndex ?gyObj.limit : qgObj.limit"
        :currentPage="tapIndex ?gyObj.page : qgObj.page" @counterchange="counterchange" />
    </div>


    <div class="bom-div" v-if="bomShow">
      <div class="div-bg">
        <div style="padding:72px 0 6px 0 ;"><canvas id="QRCode_header"></canvas></div>
      </div>
      <el-image src="/static/imgs/close.png" fit="cover" style="width: 60px;height: 60px;padding-top: 22px" class="cupo"
        @click="bomShow = false" />

    </div>
  </div>
</template>

<script>
  import pagesK from '@/components/page'
  export default {
    metaInfo: {
      title: '聚木网-供求中心'
    },
    data() {
      return {
        qgShow: false,
        gyShow: false,
        varBox: [...this.$store.state.caizhi],
        czIndex: 0,
        gyBox: [],
        gyObj: {
          page: 1,
          limit: 20,
          categoryIds: '',
          description: ''
        },
        qgBox: [],
        qgObj: {
          page: 1,
          limit: 10,
          categoryId: '',
          title: ''
        },
        qgId: '',
        bomShow: false,
        squareUrl: '',
        tapIndex: 0,
        total: 0,
        qgLoading: true,
        gyLoading: true,

      }
    },
    watch: {
      '$store.state.searValue': {
        handler(newValue) {
          if (this.$route.path == '/demand' || this.$route.path == '/demand/') {
            if (JSON.stringify(newValue) !== '{}') {
              console.log(newValue)
              this.tapIndex = newValue.type
              this.czIndex = newValue.classify

              this.gyObj.categoryIds = newValue.classify ? this.varBox[newValue.classify].itemCode : ''
              this.qgObj.categoryId = newValue.classify ? this.varBox[newValue.classify].itemCode : ''

              this.gyObj.description = newValue.val
              this.qgObj.title = newValue.val
              this.qgObj.page = newValue.page
              this.gyObj.page = newValue.page
            } else {
              this.resetData()
            }
            this.tapIndex ? this.getGy() : this.getQg()
          }
        },
        immediate: true
      },
      '$store.state.isDetail': {
        handler(newValue) {
          console.log(this.qgId)
          if (this.qgId) {
            this.$request('get', this.$wxapi + 'buyrequests/official-site/purchase/quantity', {
              id: this.qgId
            }, (res) => {
              if (res.status == 200) {
                for (let i in this.qgBox) {
                  if (this.qgBox[i].id == res.data.data.id) {
                    this.qgBox[i].browseQuantity = res.data.data.browseQuantity
                  }
                }
              } else {
                this.$toast('查询单条浏览量失败！');
              }
            })
          }
        },
        immediate: true
      }
    },
    mounted() {

      if (!this.$store.state.caizhi.length) {
        this.$request('get', this.$wxapi + 'dict/list?dictCode=TIMBER_TYPE', {}, (res) => {
          if (res.status == 200) {
            res.data.data.unshift({
              itemValue: '全部',
              itemCode: ''
            })
            this.$store.commit('caizhi', res.data.data);
            this.varBox = res.data.data
          } else {
            this.$toast('材质请求失败');
          }
        })
      } else {
        this.varBox[0].itemValue = '全部'
      }

    },
    components: {
      pagesK
    },
    methods: {

      resetData() {
        this.tapIndex = 0
        this.czIndex = 0
        this.gyObj = {
          page: 1,
          limit: 20,
          categoryIds: '',
          description: ''
        }
        this.qgObj = {
          page: 1,
          limit: 10,
          categoryId: '',
          title: ''
        }
      },
      dataLeav() {
        for (let i in this.gyBox) {
          this.gyBox[i].black = false
        }
        this.$forceUpdate();
      },

      varClick(val, i) {
        this.czIndex = i
        this.gyObj.categoryIds = val.itemCode
        this.qgObj.categoryId = val.itemCode
        this.tapIndex ? this.getGy() : this.getQg()
      },
      baojia(id) {
        return
        this.useqrcode('qg', {
          id: id,
          link: 'index',
          channelType: '4'
        }, 200, 200)
        this.bomShow = true

      },
      fenlei(i) {
        this.gyObj.page = 1
        this.qgObj.page = 1
        this.tapIndex = i
        i ? this.getGy() : this.getQg()
      },

      seekClick(val) {

        this.qgId = val.id

      },

      getQg() {
        this.$request('get', this.$wxapi + 'buyrequests/official-site/page', this.qgObj, (res) => {
          this.qgLoading = true

          if (res.status == 200) {
            this.qgBox = res.data.data.list
            this.total = res.data.data.total
            this.qgShow = res.data.data.list.length ? false : true
            this.qgLoading = false
          } else {
            this.$notify.error({
              title: '错误',
              message: '请求失败！',
              position: 'top-left'
            });
          }
        })
      },

      getGy() {
        this.$request('get', this.$wxapi + 'supplyproduct/official-site/page', this.gyObj, (res) => {
          this.gyLoading = true

          if (res.status == 200) {
            this.gyBox = res.data.data.list
            this.total = res.data.data.total
            this.gyShow = res.data.data.list.length ? false : true
            this.gyLoading = false
          } else {
            this.$notify.error({
              title: '错误',
              message: '请求失败！',
              position: 'top-left'
            });
          }
        })
      },


      blackShow(i, val) {
        return
        for (let i in this.gyBox) {
          this.gyBox[i].black = false
        }
        this.useqrcode('gy', {
          id: val.id,
          link: 'index',
          channelType: '4'
        }, 125, 125)
        this.gyBox[i].black = true
        this.$forceUpdate();
      },
      counterchange(e) {
        if (this.tapIndex) {
          this.gyObj.page = e
          this.getGy()
        } else {
          this.qgObj.page = e
          this.getQg()
        }
        this.goTop()
      }
    }
  }
</script>

<style scoped>
  @import url('../../../static/css/demand.css');
</style>



// WEBPACK FOOTER //
// src/components/demand/index.vue